<template>
    <div
        v-if="mobileSearchOpened"
        class="absolute top-0 left-0 z-20 flex flex-col w-full h-screen overflow-y-scroll bg-white"
    >
        <div class="grid grid-cols-2 gap-10 p-6">
            <!-- header -->
            <div class="flex justify-between col-span-2 gap-6">
                <!-- search bar -->
                <div class="flex-1">
                    <form
                        id="mobile-search-form"
                        ref="mobileSearchForm"
                        action="/search"
                        method="GET"
                        class="relative flex flex-shrink w-40 transition-all duration-500"
                    >
                        <input
                            aria-label="Search"
                            id="mobile-search-input"
                            ref="mobileSearchInput"
                            v-model="mobileSearchString"
                            v-on:focus="mobileSearchInputFocus"
                            v-on:keyup="mobileSearchInputType"
                            name="keywords"
                            type="search"
                            autocomplete="off"
                            v-bind:placeholder="placeholder"
                            class="bg-transparent block w-full rounded py-2.5 pl-6 pr-10 sm:text-sm border-2 border-xp-electron-green/30 focus:border-xp-electron-green/50 focus:ring-0 uppercase text-[13px] font-bold tracking-[2.5px] text-black"
                        />
                        <button
                            ref="mobileSearchButton"
                            type="submit"
                            class="absolute inset-y-0 right-0 flex items-center pr-4"
                        >
                            <svg class="w-5 h-5 text-black" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                            </svg>
                        </button>
                    </form>
                </div>
                <!-- close button -->
                <div class="flex items-center cursor-pointer">
                    <svg v-on:click="mobileSearchClose" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 18.7792L18.5505 5.22872" stroke="#d4d7de" stroke-width="1.5" stroke-miterlimit="20" stroke-linecap="round"></path> <path d="M18.5506 18.5505L5.00003 5" stroke="#d4d7de" stroke-width="1.5" stroke-miterlimit="20" stroke-linecap="round"></path></svg>
                </div>
            </div>
            <!-- search results -->
            <div
                v-show="!hideDefaultResults"
                class="grid grid-cols-2 col-span-2 gap-5"
            >
                <a
                    v-for="(result, i) in defaultResults"
                    :key="i + '_default'"
                    class="col-span-1 group flex flex-col overflow-hidden border border-xp-light-grey shadow-xp rounded bg-white"
                    :href="result.url"
                >
                    <img
                        class="object-cover object-center w-full h-28"
                        :src="mobileSearchOpened ? result.image : imagePlaceholder"
                        alt=""
                    />
                    <div class="p-3">
                        <span
                            v-text="result.title"
                            class="block text-lg font-bold tracking-wider leading-5"
                        >
                        </span>
                    </div>
                    <!-- <span class="flex justify-center pt-3 mt-auto">
                        <svg width="53" height="39" viewBox="0 0 53 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33.3499 37.7999C23.4087 37.7999 15.3499 29.7411 15.3499 19.7999C15.3499 9.8588 23.4087 1.79992 33.3499 1.79992C43.291 1.79992 51.3499 9.8588 51.3499 19.7999C51.3499 29.7411 43.291 37.7999 33.3499 37.7999V37.7999Z" stroke="#5DE174" stroke-opacity="0.3" stroke-width="2" stroke-miterlimit="20"></path> <path d="M31.53 24.3202L36.53 19.4702L31.53 14.5552" stroke="#5DE174" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M35.5896 19.4603L1.74951 19.4603" stroke="#5DE174" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round"></path></svg>
                    </span> -->
                    <div class="mt-auto flex items-center justify-end">
                        <div class="group inline-flex items-center gap-3 px-3 py-4 bg-transparent hover:bg-xp-electron-green group-hover:bg-xp-electron-green rounded-sm">
                            <svg class="shrink-0 text-black group-hover:translate-x-1 transition-transform group-hover:text-black" width="38" height="13" viewBox="0 0 38 13" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M31.3202 11.3001L36.3602 6.41757L31.3202 1.53506" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round" /><path d="M35.4 6.44L1.55994 6.43997" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" /></svg>
                        </div>
                    </div>
                </a>
            </div>
            <div
                v-show="hideDefaultResults"
                class="grid grid-cols-2 col-span-2 gap-5"
            >
                <a
                    v-for="result in results.top4"
                    :key="result.id"
                    class="col-span-1 group flex flex-col overflow-hidden border border-xp-light-grey shadow-xp rounded bg-white"
                    :href="result.url"
                    :target="result.type == 'custom_results' ? '_blank' : '_self'"
                >
                    <span v-if="!result.image && result.type == 'custom_results'" class="py-4 flex justify-center">
                        <svg height="93.5" viewBox="0 0 120 121" width="93" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><clipPath id="a"><path d="m1700 0v5886h-1700v-5886z"/></clipPath><clipPath id="b"><path d="m2.056 0c.41066667 0 .76333333.04866667 1.058.146s.53733333.23133333.728.402.33133333.372.422.604.136.48266667.136.752c0 .29066667-.04666667.55733333-.14.8s-.236.45066667-.428.624-.43533333.30866667-.73.406-.64333333.146-1.046.146h-.704v1.948h-1.352v-5.828zm0 1.012h-.704v1.848h.704c.352 0 .60533333-.084.76-.252s.232-.40266667.232-.704c0-.13333333-.02-.25466667-.06-.364s-.10066667-.20333333-.182-.282-.184-.13933333-.308-.182-.27133333-.064-.442-.064z"/></clipPath><clipPath id="c"><path d="m2.264 0c.45333333 0 .866.07333333 1.238.22s.69.34933333.954.608.46866667.566.614.922.218.74333333.218 1.162c0 .42133333-.07266667.81-.218 1.166s-.35.664-.614.924-.582.46266667-.954.608-.78466667.218-1.238.218h-2.264v-5.828zm0 1.04h-.904v3.748h.904c.25866667 0 .48933333-.04333333.692-.13s.374-.21066667.514-.372.24733333-.358.322-.59.112-.49333333.112-.784c0-.288-.03733333-.548-.112-.78s-.182-.42866667-.322-.59-.31133333-.28533333-.514-.372-.43333333-.13-.692-.13z"/></clipPath><clipPath id="d"><path d="m3.752 0v1.04h-2.392v1.476h1.992v1.044h-1.992v2.268h-1.36v-5.828z"/></clipPath><clipPath id="e"><path d="m60 0c33.137085 0 60 26.862915 60 60s-26.862915 60-60 60-60-26.862915-60-60 26.862915-60 60-60zm0 2c-32.0325155 0-58 25.9674845-58 58s25.9674845 58 58 58 58-25.9674845 58-58-25.9674845-58-58-58z"/></clipPath><clipPath id="f"><path d="m22.2773906 0c1.7301755 0 3.3761317.74688259 4.5154602 2.04897235l10.7226094 12.25441065c.9570303 1.093749 1.4845398 2.4976888 1.4845398 3.9510277v27.7455893c0 3.3137085-2.6862915 6-6 6h-27c-3.3137085 0-6-2.6862915-6-6v-40c0-3.3137085 2.6862915-6 6-6zm0 2.5h-16.2773906c-1.93299662 0-3.5 1.56700338-3.5 3.5v40c0 1.9329966 1.56700338 3.5 3.5 3.5h27c1.9329966 0 3.5-1.5670034 3.5-3.5v-27.7455893c0-.847781-.3077139-1.6667459-.8659816-2.3047661l-10.7226093-12.25441073c-.6646083-.75955236-1.6247494-1.19523387-2.6340185-1.19523387z"/></clipPath><clipPath id="g"><path d="m8.42287817 3.15893703c.2312721 1.51055462.06553767 3.51185706-.42888759 5.63178929l.02793794.03442942.04982408-.01478901-.01680701.05287531.02693925.03093955c1.89225281-.34945262 3.66256646-.40531649 4.96172706-.11496886 1.8899336.4223787 2.9228733 1.66534077 2.3724378 3.43603837-.584361 1.8798326-2.1173182 2.4944904-3.928748 1.8390894-1.1707389-.42359-2.49489131-1.3730899-3.81013521-2.6715715l-.29531363-.2970678-.05178524.0138551c-.6131052 1.7751936-1.38551706 3.2878347-2.22626096 4.2835117l-.177701.2015916c-1.29186118 1.4014737-2.8726923 1.6414243-4.13021929.2884707-1.27842103-1.3754332-.95314577-2.9730738.52120988-4.2327101 1.01157733-.8642551 2.59452861-1.6245297 4.43587323-2.18283394l.05042534-.18059827c-1.27244279-1.62078141-2.26101279-3.32067048-2.73749756-4.76780116l-.09343485-.30349093c-.6061327-2.12116682-.00987479-3.79365602 1.97324286-4.1492569 1.94215245-.34825524 3.14655552.9430694 3.4771729 3.10249803zm-3.55002531 8.72776417c-.94926928.3888448-1.7346638.828385-2.25661153 1.2743183-.69164018.5909124-.75808821.9172823-.35542299 1.3505035.35747963.3846068.61607989.3453544 1.19473585-.2823996.45457577-.4931459.91951535-1.2521925 1.34705935-2.1831384zm5.25837034-1.2526991-.29337034.0266991.18455524.1576648c.7072107.5935497 1.3789927 1.0355205 1.9564432 1.2808557l.188909.0744338c.8011178.2898558 1.1159528.1636189 1.3384388-.5520967.1497932-.4818702-.0280704-.6958979-.8988033-.8904968-.6451237-.1441778-1.504364-.174847-2.4761726-.0970599zm-4.83251998-8.60896145c-.58089309.1041623-.72447141.50689604-.40321328 1.63114171.23244661.813449.71205778 1.7936648 1.36189172 2.81205521l.1114712.17146363.01327738-.08456978c.14818391-1.06667568.18450872-2.04498763.09740605-2.83666714l-.03362147-.25684606c-.18066745-1.18003011-.52414963-1.54830134-1.1472116-1.43657757z"/></clipPath><g clip-path="url(#a)" transform="translate(-1379 -248)"><g transform="translate(1429.917714 317.77698)"><g clip-path="url(#b)"><path d="m0 0h4.4v5.828h-4.4z" fill="#5de174"/></g><g clip-path="url(#c)" transform="translate(6.646857)"><path d="m0 0h5.288v5.828h-5.288z" fill="#5de174"/></g><g clip-path="url(#d)" transform="translate(14.125714)"><path d="m0 0h3.752v5.828h-3.752z" fill="#5de174"/></g></g><g clip-path="url(#e)" transform="matrix(0 -1 1 0 1379 368.5)"><path d="m0 0h120v120h-120z" fill="#5de174"/></g><g clip-path="url(#f)" transform="translate(1420 282)"><path d="m0 0h39v52h-39z" fill="#5de174"/></g><g clip-path="url(#g)" transform="translate(1431.217147 294.011299)"><path d="m0 0h15.5636251v16.771262h-15.5636251z" fill="#5de174"/></g></g></svg>
                    </span>
                    <span v-else class="px-3 pt-3">
                        <img
                            :src="result.image"
                            alt=""
                        />
                    </span>
                    <div class="p-3">
                        <span
                            v-text="result.title"
                            class="block text-lg font-bold tracking-wider"
                        >
                        </span>
                    </div>
                    <!-- <span class="flex justify-center pt-3 mt-auto">
                        <svg width="53" height="39" viewBox="0 0 53 39" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M33.3499 37.7999C23.4087 37.7999 15.3499 29.7411 15.3499 19.7999C15.3499 9.8588 23.4087 1.79992 33.3499 1.79992C43.291 1.79992 51.3499 9.8588 51.3499 19.7999C51.3499 29.7411 43.291 37.7999 33.3499 37.7999V37.7999Z" stroke="#5DE174" stroke-opacity="0.3" stroke-width="2" stroke-miterlimit="20"></path> <path d="M31.53 24.3202L36.53 19.4702L31.53 14.5552" stroke="#5DE174" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M35.5896 19.4603L1.74951 19.4603" stroke="#5DE174" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round"></path></svg>
                    </span> -->
                    <div class="mt-auto flex items-center justify-end">
                        <div class="group inline-flex items-center gap-3 px-3 py-4 bg-transparent hover:bg-xp-electron-green group-hover:bg-xp-electron-green rounded-sm">
                            <svg class="shrink-0 text-black group-hover:translate-x-1 transition-transform group-hover:text-black" width="38" height="13" viewBox="0 0 38 13" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M31.3202 11.3001L36.3602 6.41757L31.3202 1.53506" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round" /><path d="M35.4 6.44L1.55994 6.43997" stroke="currentColor" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" /></svg>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Hub from '../../events/hub'
import debounce from 'lodash.debounce'

export default {
    name: 'MobileSearch',
    props: {
        endpoint: {
            required: true,
            type: String,
        },
        topQueries: {
            required: true,
            type: String,
            default: '[]',
        },
        imagePlaceholder: {
            required: true,
            type: String,
        },
        placeholder: {
            required: false,
            type: String,
            default: 'Search',
        }
    },
    data: () => ({
        keywords: '',
        mobileSearchOpened: false,
        mobileSearchString: '',
        defaultResults: [
            {
                title: 'AC-DC Power Supplies',
                url: '/products/ac-dc-power-supplies',
                // image: '/images/search/search-prod-AC-DC.jpg'
                image: '/storage/blocks/2023/home-prod-AC-DC-power.jpg'
            },
            {
                title: 'DC-DC Converters',
                url: '/products/dc-dc-converters',
                // image: '/images/search/search-prod-DC-DC.jpg'
                image: '/storage/blocks/2023/home-prod-DC-DC-power.jpg'
            },
            {
                title: 'High Voltage AC-DC',
                url: '/products/high-voltage-power-solutions?product_type=High%20Voltage%20AC-DC ',
                // image: '/images/search/search-prod-HV-AC.jpg'
                image: '/storage/blocks/2023/home-prod-HVAC-power.jpg'
            },
            {
                title: 'High Voltage DC-DC',
                url: '/products/high-voltage-power-solutions?product_type=High%20Voltage%20DC-DC ',
                // image: '/images/search/search-prod-HV-DC.jpg'
                image: '/storage/blocks/2023/home-prod-HVDC-power.jpg'
            }
        ],
        suggestions: [],
        results: [],
        showDropdown: false
    }),
    computed: {
        hideDefaultResults() {
            return this.results
                && this.results.count > 0
                && this.results.top4
                && this.results.top4[0]
        }
    },
    watch: {
        mobileSearchString: function (newSearch, oldSearch) {
            if (oldSearch.length > 0 && newSearch.length == 0) {
                this.mobileSearchDropdownReset()
            }
        }
    },
    created() {
        Hub.$on('mobile-search-open', this.mobileSearchOpen)
    },
    mounted() {
        this.suggestions = JSON.parse(this.topQueries)
    },
    methods: {
        // getProductImage(image) {
        //     return this.results.storage_url + image
        // },
        // getProductLink(name) {
        //     return this.results.link_url + name + '-Series'
        // },
        // getProductName(name) {
        //     return name + ' Series'
        // },
        async getSearchResult(keywords) {
            const response = await axios(this.endpoint+'?keywords='+keywords)

            let data = await response.data

            this.results = data
        },
        // async getSuggestions() {
        //     const response = await axios('/top-queries')

        //     let data = await response.data

        //     this.suggestions = data
        // },
        mobileSearchOpen() {
            document.body.classList.add('overflow-hidden')
            document.body.classList.add('max-h-screen')
            this.mobileSearchOpened = true
        },
        mobileSearchClose() {
            document.body.classList.remove('max-h-screen')
            document.body.classList.remove('overflow-hidden')
            this.mobileSearchOpened = false
        },
        mobileSearchDropdownReset() {
            this.results = []
        },
        mobileSearchInputFocus() {
            let formElement = this.$refs.mobileSearchForm

            formElement.classList.remove('w-40')
            formElement.classList.add('w-full')
        },
        searchInputSubmit(keywords) {
            this.getSearchResult(keywords)
        },
        mobileSearchInputType: debounce( function ($event) {
            this.getSearchResult($event.target.value)
        }, 500)
    }
}
</script>
